module.exports = __webpack_public_path__ + "static/media/Capacidad60-alta.97c75db2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/Capacidad60-alta.svg
// module id = 155
// module chunks = 0